import { Injectable } from '@angular/core';
import { UserConfig } from './models/user-config.model';
import { UserConfigResponse } from './models/user-config.response';

@Injectable({
  providedIn: 'root',
})
export class UserConfigFactory {
  buildUserConfig(userConfigResponse: UserConfigResponse): UserConfig {
    return {
      recommendationsDialogInfo: userConfigResponse.persistentPatronConfiguration.recommendationsDialogInfo,
      pendingNotifications: userConfigResponse.volatilePatronConfiguration.pendingNotifications,
    };
  }
}
